import { render } from "./UpdateSpecialPaymentRequestPO.vue?vue&type=template&id=41f6061b&scoped=true"
import script from "./UpdateSpecialPaymentRequestPO.vue?vue&type=script&lang=ts"
export * from "./UpdateSpecialPaymentRequestPO.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-41f6061b"

export default script